import React, { useState, useEffect, useRef } from 'react';
import Header from '../Common_Files/Header';
import Footer from '../Common_Files/Footer';
import config from '../Common_Files/Config';
import ViewProduct from '../Master/ViewProduct';
import ProductList from "./ProductListModel";
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import $ from 'jquery';
import 'datatables.net-bs5';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import Select from 'react-select';
import { useNavigate } from "react-router-dom";
import { fetchCustomerData, handleCustomerChange, fetchWarehouseData, handleProductAdd, handleProductAddNew, handleSalesProductAddNew, getDeliveryAddrById, setBatchToProduct, setSalesBatchToProduct, setSalesBatchToProductNew, handleBatchChange, handleSalesBatchChange, handleSalesBatchChangeNew } from '../../services/NewSalesService';
import { fetchProductData, removeRow, handleInputChangeInSales, handleInputChangeInSalesNew } from '../../services/NewPurchaseOrderService';
import CustomDateInput from '../CommonComp/CustomDateInput';
import FormText from '../CommonComp/FormText';

const NewSalesOrder = () => {
  const accessToken = localStorage.getItem('accessToken');
  const [draw, setDraw] = useState(1);
  const [start, setStart] = useState(0);
  const [length, setLength] = useState(50);
  const [deliveryAddresses, setDeliveryAddresses] = useState([]);
  const [inputDeliveryAddresses, setInputDeliveryAddresses] = useState({
    address_line1: '',
    address_line2: '',
    city: '',
    country: '',
    post_code: '',
  });
  const [deliveryAddrDropdown, setDeliveryAddrDropdown] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [invoiceAddress, setInvoiceAddress] = useState({
    billing_address_line1: '',
    billing_address_line2: '',
    billing_city: '',
    billing_country: '',
    billing_postcode: '',
    vat_number: '',
    sales_country: '',
  });
  const [customerData, setCustomerData] = useState([]);
  const [warehouseData, setWarehouseData] = useState([]);
  const [productData, setProductData] = useState([]);
  const [tableRows, setTableRows] = useState([]);
  const [stdGoods, setStdGoods] = useState(0);
  const [vatAmt, setVatAmt] = useState(0);
  const [zeroGoods, setZeroGoods] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [grossWeight, setGrossWeight] = useState(0);
  const [netWeight, setNetWeight] = useState(0);
  const [cube, setCube] = useState(0);
  const [productBatch, setProductBatch] = useState([]);
  const [grossProfit, setGrossProfit] = useState(0);
  const [grossProfitPercent, setGrossProfitPercent] = useState(0);
  const [productSO, setProductSO] = useState([]);
  const navigateToOrderHistory = useNavigate();
  const productBatchRef = useRef(null);
  const productListRef = useRef(null);
  const [modalData, setModalData] = useState(null);
  const CreatePOModal = useRef(null);
  const [selectedBatchId, setSelectedBatchId] = useState([]);
  const [selectedpurchaseId, setSelectedpurchaseId] = useState([]);
  const [selectedUnallocation, setSelectedUnallocation] = useState(null);
  const [selectedCost, setSelectedCost] = useState(0);
  const AssignBatchModal = useRef(null);
  const [requiredQty, setRequiredQty] = useState(0);
  const [selectedProductId, setSelectedProductId] = useState(null);
  // Validation state variables
  const [fieldErrors, setFieldErrors] = useState({});
  const [jobRefError, setJobRefError] = useState('');
  const [bookingRefError, setBookingRefError] = useState('');
  const [notesError, setNotesError] = useState('');
  const [addressErrors, setAddressErrors] = useState({});

  const [totalVal, setTotalVal] = useState({
    stdGoods: 0,
    zeroGoods: 0,
    vatAmt: 0,
    grandTotal: 0,
    totalItems: 0,
    grossWeight: 0,
    netWeight: 0,
    cbm: 0,
    totalProfitPercent: 0,
    totalProfit: 0,
    totalProfit1: 0,
  });
  console.log(modalData);
  const [deliveryType, setDeliveryType] = useState('delivery');
  const [saveAsProforma, setSaveAsProforma] = useState(false);
  const [inputCollectionAddresses, setInputCollectionAddresses] = useState({
    address_line1: '',
    address_line2: '',
    city: '',
    country: '',
    post_code: '',
  });

  // Fixed hasMappedPO calculation - using useMemo for better performance
  const hasMappedPO = React.useMemo(() => {
    const result = tableRows.some(row => {
      // Check if batch_id is not 0 and not an empty array
      const hasBatchId = Array.isArray(row.batch_id)
        ? row.batch_id.length > 0
        : (row.batch_id !== 0 && row.batch_id !== null && row.batch_id !== undefined);

      // Check if purchase_id is not 0 and not an empty array
      const hasPurchaseId = Array.isArray(row.purchase_id)
        ? row.purchase_id.length > 0
        : (row.purchase_id !== 0 && row.purchase_id !== null && row.purchase_id !== undefined);

      // Check if mappedPO exists and is not empty
      const hasMappedPO = row.mappedPO && row.mappedPO !== '';

      return hasBatchId || hasPurchaseId || hasMappedPO;
    });

    console.log('hasMappedPO calculated:', result);
    console.log('TableRows with mapping info:', tableRows.map(row => ({
      id: row.id,
      batch_id: row.batch_id,
      purchase_id: row.purchase_id,
      mappedPO: row.mappedPO
    })));
    return result;
  }, [tableRows]);

  const handleDeliveryandCollectionAddress = (e) => {
    setDeliveryType(e.target.value);
    setInputDeliveryAddresses({
      address_line1: '',
      address_line2: '',
      city: '',
      country: '',
      post_code: '',
    });
  };

  useEffect(() => {
    $('#dsTable tbody').off('click', '.applybtn');
    $('#dsTable tbody').on('click', '.applybtn', function () {
      $('#freestock').empty();
      $('#stock').empty();
      $('#on_so').empty();
      $('#allocation').empty();
      $('#onpf').empty();
      $('#onpo').empty();
      const product_id = $(this).data('id');
      const formData = new FormData();
      formData.append('id', product_id);
      document.getElementById('viewProductForm').reset();
      const fetchProductData = async () => {
        const apiUrl = `${config.api_url}/ws-get-products-by-id`;
        try {
          const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
              'Authorization': `Bearer ${accessToken}`
            },
            body: formData,
          });

          const data = await response.json();
          $('#code').val(data.products[0].code);
          $('#packValue').val(data.products[0].pack);
          $('#vat').val(data.products[0].vat);
          $('#weight').val(data.products[0].gross_weight);
          $('#supplier').val(data.products[0].supplier_name);
          $('#description').val(data.products[0].product_desc);
          $('#sizeValue').val(data.products[0].size);
          $('#barcode').val(data.products[0].unit_barcode);
          $('#view_case_barcode').val(data.products[0].case_barcode);
          $('#pallet_qty').val(data.products[0].pallet_qty);
          $('#case_price').val(data.products[0].price);
          $("#product_status").html(data.products[0].status !== 0
            ? 'Status : <span style="margin-left: 5px;" class="badge bg-success">Active</span>'
            : 'Status : <span style="margin-left: 5px;" class="badge bg-secondary"> Inactive</span>'
          );
          $('#viewcbm').val(data.products[0].cbm);
          $('#brandname').val(data.products[0].brand);
          $('#categooryName').val(data.products[0].category);
          $('#editnetWeight').val(data.products[0].net_weight);
          $('#editgrossWeight').val(data.products[0].gross_weight);
          const isDEL001 = data.products[0].code === 'DEL001';
          $('#freestock').append(isDEL001 ? 0 : (data.freestock == null ? 0 : data.freestock));
          $('#stock').append(isDEL001 ? 0 : parseInt(data.products[0].quantity));
          $('#on_so').append(isDEL001 ? 0 : (data.onso == null ? 0 : data.onso));
          $('#allocation').append(isDEL001 ? 0 : (data.allocation == null ? 0 : data.allocation));
          $('#onpf').append(isDEL001 ? 0 : (data.pf == null ? 0 : data.pf));
          $('#onpo').append(isDEL001 ? 0 : (data.on_purchase == null ? 0 : data.on_purchase));
        }
        catch (error) {
          console.error("Error fetching product data:", error);
        }
      };
      fetchProductData();
    });

    return () => {
      $('#dsTable tbody').off('click', '.applybtn');
    };
  }, []);

  useEffect(() => {
    if (!accessToken) {
      window.location.href = '/login';
      return;
    }
    const calculateTotals = () => {
      const isOutOfUK = invoiceAddress && (invoiceAddress.sales_country === '0' || invoiceAddress.sales_country === 0);
      
      const stdGoods = tableRows
        .filter(item => item.vat !== '0.00' && item.vat !== null)
        .reduce((sum, item) => {
          const code = String(item.code || '').trim().toUpperCase();
          const isDEL001 = code === 'DEL001';
          if (isDEL001) return sum;
          const itemValue = parseFloat(item.price || 0) * parseFloat(item.pdtqty || 0);
          return sum + itemValue;
        }, 0);

      const zeroGoods = tableRows
        .filter(item => item.vat === '0.00' || item.vat === null)
        .reduce((sum, item) => {
          const code = String(item.code || '').trim().toUpperCase();
          const isDEL001 = code === 'DEL001';
          if (isDEL001) return sum;
          const itemValue = parseFloat(item.price || 0) * parseFloat(item.pdtqty || 0);
          return sum + itemValue;
        }, 0);

      const vatAmt = isOutOfUK ? 0 : tableRows.reduce((sum, item) => {
        const code = String(item.code || '').trim().toUpperCase();
        const isDEL001 = code === 'DEL001';
        if (isDEL001) return sum;
        const baseValue = parseFloat(item.price || 0) * parseFloat(item.pdtqty || 0);
        const itemVat = (baseValue * (parseFloat(item.vat || 0) / 100)) || 0;
        return sum + itemVat;
      }, 0);

      const grandTotal = stdGoods + zeroGoods + vatAmt;

      const totalItems = tableRows.reduce((sum, item) => {
        const itemCount = parseInt(item.pdtqty || 0);
        return sum + itemCount;
      }, 0);

      const grossWeight = tableRows.reduce((sum, item) => {
        if (isSpecialLineItem(item.code)) return sum;
        const grossWeightCount = parseInt(item.pdtqty || 0) * parseFloat(item.grossWeight || 0);
        return sum + grossWeightCount;
      }, 0);

      const netWeight = tableRows.reduce((sum, item) => {
        if (isSpecialLineItem(item.code)) return sum;
        const netWeightCount = parseInt(item.pdtqty || 0) * parseFloat(item.netWeight || 0);
        return sum + netWeightCount;
      }, 0);

      const cbm = tableRows.reduce((sum, item) => {
        if (isSpecialLineItem(item.code)) return sum;
        const cbmCount = parseInt(item.pdtqty || 0) * parseFloat(item.cbm || 0);
        return sum + cbmCount;
      }, 0);

      let totalCost = tableRows.reduce((cost, row) => {
        const code = String(row.code || '').trim().toUpperCase();
        const isDEL001 = code === 'DEL001';
        if (isDEL001) return cost;
        const rowCost = parseFloat(row.cost || 0) * parseFloat(row.pdtqty || 0);
        return cost + rowCost;
      }, 0);
      
      let totalProfit1 = tableRows.reduce((profit, row) => {
        const code = String(row.code || '').trim().toUpperCase();
        const isDEL001 = code === 'DEL001';
        if (isDEL001) {
          const del001Cost = parseFloat(row.cost || 0);
          return profit - del001Cost;
        }
        const rowProfit = ((parseFloat(row.price || 0) - parseFloat(row.cost || 0)) * parseFloat(row.pdtqty || 0));
        return profit + rowProfit;
      }, 0);
      
      const totalRevenue = stdGoods + zeroGoods;
      let totalProfitPercent = totalRevenue > 0 ? (totalProfit1 / totalRevenue) * 100 : 0;

      const totalProfit = tableRows.reduce((profit, row) => {
        const code = String(row.code || '').trim().toUpperCase();
        const isDEL001 = code === 'DEL001';
        if (isDEL001) {
          const del001Cost = parseFloat(row.cost || 0);
          return profit - del001Cost;
        }
        const rowProfit = ((parseFloat(row.price || 0) - parseFloat(row.cost || 0)) * parseFloat(row.pdtqty || 0));
        return profit + rowProfit;
      }, 0);

      setTotalVal({
        stdGoods,
        zeroGoods,
        vatAmt,
        grandTotal,
        totalItems,
        grossWeight,
        netWeight,
        cbm,
        totalProfit,
        totalProfitPercent,
      });
    };

    calculateTotals();
  }, [tableRows, invoiceAddress]);

  const closeAssignBatchModal = (event) => {
    if (AssignBatchModal.current) {
      const bsModal = window.bootstrap.Modal.getInstance(AssignBatchModal.current);
      if (bsModal) bsModal.hide();
    }
  }



  const handleBatchAssignementSubmit = (e) => {
    if (productBatch.length === 0) {
      console.error("No batches available.");
      return;
    }

    const itemId = productBatch[0].product_id;
    const selectedItem = productBatch.find(item => item.id === itemId);

    setSalesBatchToProductNew(productBatch[0].product_id, selectedBatchId, selectedpurchaseId, setTableRows, selectedCost);
    closeAssignBatchModal();





  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (selectedBatchId) {
      fetch(`${config.api_url}/ws-batch-allocation`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ selectedBatchId }),
      })
        .then(response => response.json())
        .then(data => {
          // Handle response
        })
        .catch(error => {
          console.error('Error:', error);
        });
    } else {
      alert("Please select a batch before submitting.");
    }
  };

  const handleOpenPastPurchaseModal = (data) => {
    setModalData(data);
    if (productBatchRef.current) {
      productBatchRef.current();
    }
  };

  const handleOpenProductListModal = (data) => {
    setModalData(data);
    if (productListRef.current) {
      productListRef.current();
    }
  };

  const getProductList = async (id = null) => {
    try {
      const formData = new FormData();
      if (id) {
        formData.set("product_id", id);
      }

      const response = await axios.post(
        `${config.api_url}/ws-get-products`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      const data = response.data;
      setProductBatch(data.products);
      handleOpenProductListModal(data.products);
    } catch (error) {
      console.error("Error fetching product batch data:", error);
    }
  };

  useEffect(() => {
    $('.data').hide();
    $('.clickherebtn').on('click', function (event) {
      event.preventDefault();
      $('.data').toggle();
    });

    return () => {
      $('button').off('click');
    };
  }, []);

  useEffect(() => {
    fetchProductData(setProductData);
    fetchCustomerData(setCustomerData);
    fetchWarehouseData(setWarehouseData);
  }, []);

  const getProductBatchData = async (id, batch_id = null, purchase_id = null) => {
    setProductBatch([]);
    setSelectedpurchaseId([]);
    try {
      const formData = new FormData();
      formData.set('product_id', id);

      const response = await axios.post(
        `${config.api_url}/ws-batch-info-by-product-id`,
        formData,
        {
          headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      const data = response.data;
      console.log(data.batch);

      const updatedBatch = data.batch.map(item => ({
        ...item,
        batch_id: batch_id || null
      }));

      setProductBatch(updatedBatch);
      
      // Set modalData with product_id for ViewProduct component
      setModalData({ ...data.batch, product_id: id });
      
      handleOpenPastPurchaseModal(data.batch);
      setSelectedBatchId(batch_id || []);
      setSelectedpurchaseId(purchase_id || []);

      // Determine required quantity for this product from tableRows
      const matchedRow = tableRows.find((row) => Number(row.id) === Number(id));
      setRequiredQty(matchedRow ? Number(matchedRow.pdtqty) || 0 : 0);

      //selectedBatchId

    } catch (error) {
      console.error("Error fetching product batch data:", error);
    }
  };

  // Helper to compute if a batch checkbox should be disabled based on required qty and selected batches
  const isBatchCheckboxDisabled = (item) => {
    const normalizedSelectedIds = Array.isArray(selectedBatchId)
      ? selectedBatchId
      : (selectedBatchId ? [selectedBatchId] : []);

    const getUnalloc = (batchItem) => {
      const qty = Number(batchItem?.qty || 0);
      const alloc = Number(batchItem?.allocation || 0);
      return Math.max(0, qty - alloc);
    };

    const selectedUnallocSum = normalizedSelectedIds.reduce((sum, selId) => {
      const selNum = Number(selId);
      const found = productBatch.find((b) => Number(b.id) === selNum);
      return sum + (found ? getUnalloc(found) : 0);
    }, 0);

    const requirement = Number(requiredQty || 0);
    if (requirement <= 0) return false;

    // If current selection already fulfills requirement, lock other checkboxes
    if (selectedUnallocSum >= requirement) {
      return !normalizedSelectedIds.map((v) => Number(v)).includes(Number(item.id));
    }

    // Allow choosing any batches while requirement not yet fulfilled
    return false;
  };

  const submitSalesOrderForm = async (type) => {
    const form = document.getElementById('new_sales_order');
    const formData = new FormData(form);
    let save_status = formData.get('save_as_proforma');
    let delivery_date = formData.get('delivery_date');
    let customerId = formData.get('customer_id');
    let customerRef = formData.get('customer_ref');

    if (customerId === '') {
      Swal.fire({
        title: "Failed!",
        text: "Please Select Customer.",
        icon: "error",
        timer: 1500,
        showConfirmButton: false,
      });
      return;
    }

    if (!customerRef || customerRef.trim() === '') {
      Swal.fire({
        title: "Failed!",
        text: "Please enter Customer Reference.",
        icon: "error",
        timer: 1500,
        showConfirmButton: false,
      });
      return;
    }

    const hasValidProduct = tableRows.some((row) => {
      const rowCode = row?.code?.toString().trim() || '';
      const isSpecial = isSpecialLineItem(rowCode);
      const quantity = parseInt(row.pdtqty || 0, 10);
      const quantityString = String(row.pdtqty || '').trim();
      
      console.log('Row validation:', {
        code: rowCode,
        isSpecial: isSpecial,
        pdtqty: row.pdtqty,
        quantity: quantity,
        quantityString: quantityString,
        willReturn: isSpecial ? false : (isNaN(quantity) || quantity === 0 || quantityString === '')
      });
      
      if (isSpecial) {
        return false;
      }
      return isNaN(quantity) || quantity === 0 || quantityString === '';
    });

    console.log('hasValidProduct:', hasValidProduct);

    if (hasValidProduct) {
      Swal.fire({
        title: "Error!",
        text: "Please input case quantity for each product.",
        icon: "error",
        timer: 1500,
        showConfirmButton: false,
      });
      return;
    }

    if (delivery_date === '') {
      formData.set('delivery_date', '0000-00-00');
    }

    let status = 'SO';
    if (save_status === 'on') {
      status = 'PF';
    }

    formData.append(`status`, status);
    formData.append(`reqType`, type);

    // Add invoice address data
    formData.append(`billing_address_line1`, invoiceAddress.billing_address_line1 || '');
    formData.append(`billing_address_line2`, invoiceAddress.billing_address_line2 || '');
    formData.append(`billing_city`, invoiceAddress.billing_city || '');
    formData.append(`billing_country`, invoiceAddress.billing_country || '');
    formData.append(`billing_postcode`, invoiceAddress.billing_postcode || '');
    formData.append(`sales_country`, invoiceAddress.sales_country || '');

    // Add delivery address data
    formData.append(`delivery_address_line1`, inputDeliveryAddresses.address_line1 || '');
    formData.append(`delivery_address_line2`, inputDeliveryAddresses.address_line2 || '');
    formData.append(`delivery_city`, inputDeliveryAddresses.city || '');
    formData.append(`delivery_country`, inputDeliveryAddresses.country || '');
    formData.append(`delivery_post_code`, inputDeliveryAddresses.post_code || '');

    // Add collection address data
    formData.append(`collection_address_line1`, inputCollectionAddresses.address_line1 || '');
    formData.append(`collection_address_line2`, inputCollectionAddresses.address_line2 || '');
    formData.append(`collection_city`, inputCollectionAddresses.city || '');
    formData.append(`collection_country`, inputCollectionAddresses.country || '');
    formData.append(`collection_post_code`, inputCollectionAddresses.post_code || '');

    if (tableRows.length === 0) {
      Swal.fire({
        title: "Failed!",
        text: "Please Select Product.",
        icon: "error",
        timer: 1500,
        showConfirmButton: false,
      });
      return;
    } else {
      // Manually append the table rows data
      tableRows.forEach((row, index) => {
        const isSpecial = isSpecialLineItem(row.code);
        formData.append(`code[${index}]`, row.code);
        formData.append(`packsize[${index}]`, row.pack || '');
        formData.append(`productSize[${index}]`, row.size || '');
        formData.append(`qty[${index}]`, isSpecial ? (row.pdtqty || 0) : row.pdtqty);
        formData.append(`price[${index}]`, row.price || 0);
        formData.append(`cost[${index}]`, isSpecial ? (row.cost || 0) : row.cost);
        formData.append(`value[${index}]`, row.value || 0);
        formData.append(`Vat[${index}]`, row.vat || 0);
        formData.append(`onSO[${index}]`, row.onSO !== undefined ? row.onSO : 0);
        formData.append(`fstk[${index}]`, row.fstk !== undefined ? row.fstk : 0);
        formData.append(`product_id[${index}]`, row.id !== undefined ? row.id : 0);
        const batchIdField = Array.isArray(row.batch_id)
          ? row.batch_id.join(',')
          : (row.batch_id !== undefined && row.batch_id !== null ? row.batch_id : 0);
        const purchaseIdField = Array.isArray(row.purchase_id)
          ? row.purchase_id.join(',')
          : (row.purchase_id !== undefined && row.purchase_id !== null ? row.purchase_id : 0);
        formData.append(`batch_id[${index}]`, batchIdField);
        formData.append(`purchase_id[${index}]`, purchaseIdField);
        formData.append(`subtotal[${index}]`, row.value !== undefined ? row.value : 0);
      });
    }

    try {
      const response = await axios.post(`${config.api_url}/ws-sales-addLatest`, formData, {
        headers: {
          authorization: `Bearer ${accessToken}`,
        }
      });

      const result = response.data;

      if (result.status === 'success') {
        Swal.fire({
          title: "Success!",
          text: "Order submitted successfully.",
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        }).then(() => {
          if (type === 'createPO') {
            navigateToOrderHistory(`/CreatePO/${result.data}`);
          } else if (type === 'leterPO') {
            navigateToOrderHistory('/CurrentSalesOrder');
          }
        });

      } else {
        Swal.fire({
          title: "Failed!",
          text: "Sales Order Failed. Try Again",
          icon: "error",
          timer: 1500,
          showConfirmButton: false,
        });
      }

      if (CreatePOModal.current) {
        const bsModal = window.bootstrap.Modal.getInstance(CreatePOModal.current);
        if (bsModal) bsModal.hide();
      }

    } catch (error) {
      console.error("Error accepting order:", error);
    }
  };

  useEffect(() => {
    if (deliveryAddresses.length > 0) {
      console.log("Delivery addresses have been updated:", deliveryAddresses);
    }
  }, [deliveryAddresses]);

  const handleSalesBatchNew = (event, setSelectedBatchId, setSelectedpurchaseId, setSelectedCost) => {
    const { value, checked } = event.target;
    // Toggle selection and then recompute purchase IDs and average net price
    setSelectedBatchId((prev) => {
      const prevArray = Array.isArray(prev) ? prev : (prev ? [prev] : []);
      const alreadySelected = prevArray.includes(value);
      let nextSelected;
      if (checked && !alreadySelected) {
        nextSelected = [...prevArray, value];
      } else if (!checked && alreadySelected) {
        nextSelected = prevArray.filter((id) => id !== value);
      } else {
        nextSelected = prevArray;
      }

      // Recompute selected purchase IDs from the productBatch list
      const nextSet = new Set(nextSelected.map(String));
      const nextPurchaseIds = productBatch
        .filter((b) => nextSet.has(String(b.id)))
        .map((b) => b.purchase_id);
      setSelectedpurchaseId(nextPurchaseIds);

      // Compute average net price across selected batches
      const selectedBatches = productBatch.filter((b) => nextSet.has(String(b.id)));
      const avgNetPrice = selectedBatches.length > 0
        ? selectedBatches.reduce((sum, b) => sum + Number(b.net_price || 0), 0) / selectedBatches.length
        : 0;
      setSelectedCost(avgNetPrice);

      return nextSelected;
    });
  };


  const handleShowInvoiceModal = (event) => {
    event.preventDefault();
    const productId = event.currentTarget.getAttribute('data-id');
    GetProductSO(productId);
  };

  const GetProductSO = async (id) => {
    try {
      const formData = new FormData();
      formData.set('product_id', id);

      const response = await axios.post(
        `${config.api_url}/ws-get-product-so`,
        formData,
        {
          headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      setProductSO(response.data.sales);
    } catch (error) {
      console.error("Error fetching product PO data:", error);
    }
  };

  const handleVatValidation = (e) => {
    const value = e.target.value;
    const alphanumericOnly = value.replace(/[^a-zA-Z0-9]/g, '').slice(0, 14);
    if (value !== alphanumericOnly) {
      e.target.value = alphanumericOnly;
    }
  };

  // Validation functions
  const validateQuantity = (value, rowId) => {
    let error = '';
    if (!/^\d{0,6}$/.test(value)) {
      error = 'Max 6 digits allowed';
    }
    setFieldErrors((prev) => ({
      ...prev,
      [rowId]: { ...prev[rowId], qty: error },
    }));
    return !error;
  };

  const validatePrice = (value, rowId) => {
    let error = '';
    if (!/^\d{0,8}(\.\d{0,2})?$/.test(value)) {
      error = 'Max 2 decimal places allowed';
    } else if (parseFloat(value) >= 1000000) {
      error = 'Value must be less than 1,000,000';
    }
    setFieldErrors((prev) => ({
      ...prev,
      [rowId]: { ...prev[rowId], price: error },
    }));
    return !error;
  };

  const isSpecialLineItem = (code) => {
    if (!code) return false;
    const codeStr = String(code).trim().toUpperCase();
    return codeStr === 'DEL001';
  };

  const validateCost = (value, rowId) => {
    let error = '';
    if (!/^\d{0,8}(\.\d{0,2})?$/.test(value)) {
      error = 'Max 2 decimal places allowed';
    }
    setFieldErrors((prev) => ({
      ...prev,
      [rowId]: { ...prev[rowId], cost: error },
    }));
    return !error;
  };

  const validateJobRef = (value) => {
    let error = '';
    if (value.length > 100) {
      error = 'Max 100 characters allowed';
    }
    setJobRefError(error);
    return !error;
  };

  const validateBookingRef = (value) => {
    let error = '';
    if (value.length > 100) {
      error = 'Max 100 characters allowed';
    }
    setBookingRefError(error);
    return !error;
  };

  const validateNotes = (value) => {
    let error = '';
    if (value.length > 500) {
      error = 'Max 500 characters allowed';
    }
    setNotesError(error);
    return !error;
  };

  const validateAddressField = (value, fieldName, addressType) => {
    let error = '';
    if (value.length > 255) {
      error = 'Max 50 characters allowed';
    }
    setAddressErrors(prev => ({ ...prev, [`${addressType}_${fieldName}`]: error }));
    return !error;
  };

  const handleSaveClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = document.getElementById('new_sales_order');
    const proformaCheckbox = form?.querySelector("input[name='save_as_proforma']");
    if (proformaCheckbox && proformaCheckbox.checked) {
      submitSalesOrderForm('leterPO');
    } else {
      const modalEl = document.getElementById('save-sales');
      if (modalEl && window.bootstrap && window.bootstrap.Modal) {
        let modal = window.bootstrap.Modal.getInstance(modalEl);
        if (!modal) modal = new window.bootstrap.Modal(modalEl);
        modal.show();
      }
    }
  };


  return (
    <div>
      <div className="modal fade" id="save-sales" tabIndex="-1" ref={CreatePOModal}>
        <div className="modal-dialog modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">&nbsp;</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <div className="add-product-popup">
                {hasMappedPO ? (
                  <h3>Submit S.O?</h3>
                ) : (
                  <h3>Do you want to create a P.O?</h3>
                )}
                <hr />
                {hasMappedPO ? (
                  <Link
                    to='#'
                    onClick={() => submitSalesOrderForm('leterPO')}
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    className="popup-innerbtn-closebtn"
                  >
                    Submit
                  </Link>
                ) : (
                  <>
                    <Link
                      to='#'
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      className="popup-innerbtn-common"
                      onClick={() => submitSalesOrderForm('createPO')}
                    >
                      Yes
                    </Link>
                    <Link
                      to='#'
                      onClick={() => submitSalesOrderForm('leterPO')}
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      className="popup-innerbtn-closebtn"
                    >
                      Later
                    </Link>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <ViewProduct product_id={selectedProductId} />

      <ProductList
        onViewPastPurchase={(showModal) => {
          productListRef.current = showModal;
        }}
        getProductBatchData={getProductBatchData}
        modalData={modalData}
        setTableRows={setTableRows}
        tableRows={tableRows}
      />

      <div className="modal fade" id="viw-pst-invs" tabIndex="-1" ref={AssignBatchModal}>
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">All Batches :  {productBatch[0]?.product_desc}  ({productBatch[0]?.code})</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <div className="partialbox">
                <h3>
                  <a href='#' data-bs-toggle="modal" data-bs-target="#vw-pst-ordr" data-id={productBatch[0]?.product_id} onClick={handleShowInvoiceModal}>View Past Invoices</a>
                </h3>
                <form id='selectBatchForm'>
                  <table className="table table-bordered dataTable">
                    <thead>
                      <tr>
                        <th>&nbsp;</th>
                        <th className="text-center">P.O. Qty</th>
                        <th className="text-center">Sold Qty</th>
                        <th className="text-center">Bal Qty</th>
                        <th className="text-center">Alloc</th>
                        <th className="text-center">UnAlloc</th>
                        <th>PO No.</th>
                        <th>Net Price</th>
                      </tr>
                    </thead>
                    <tbody>
                      {productBatch.map((item, index) => (
                        <tr key={index}>
                          <td>
                            <input
                              type="checkbox"
                              id={`batch_${item.id}`}
                              name="select_batch"
                              value={item.id}
                              data-purchaseid={item.purchase_id}
                              data-unallocation={item.qty - item.allocation}
                              data-cost={item.cost_price}
                              data-netprice={item.net_price}
                              onChange={(e) => handleSalesBatchNew(e, setSelectedBatchId, setSelectedpurchaseId, setSelectedCost)}
                              defaultChecked={Array.isArray(selectedBatchId) && selectedBatchId.includes(item.id)}
                              style={{ marginRight: '10px' }}
                              disabled={isBatchCheckboxDisabled(item)}
                            />

                            <label htmlFor={`batch_${item.id}`}>Select PO</label>
                          </td>
                          <td className="text-center">{item.qty}</td>
                          <td className="text-center">{item.sale_qty}</td>
                          <td className="text-center">{item.qty - item.sale_qty}</td>
                          <td className="text-center">{item.allocation}</td>
                          <td className="text-center">{item.qty - item.allocation}</td>
                          <td>
                            <a href={`./editNewPurchaseOrder/${item.purchase_id}`} target="_blank" rel="noopener noreferrer">
                              {item.reference_no}
                            </a>
                          </td>
                          <td className="text-end">{Number(item.net_price || 0).toFixed(2)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <a className="popup-innerbtn-common" data-bs-dismiss="modal" aria-label="Close" onClick={handleBatchAssignementSubmit} style={{ marginTop: '10px' }} > Submit</a>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="vw-pst-ordr" tabIndex="-1">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">&nbsp;All Invoices of Product : {productBatch[0]?.product_desc}  ({productBatch[0]?.code})</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <div className="partialbox">
                <table className="table table-bordered dataTable">
                  <thead>
                    <tr>
                      <th>SO#</th>
                      <th>Qty</th>
                      <th>Price </th>
                      <th>Delivered on</th>
                    </tr>
                  </thead>
                  <tbody>
                    {productSO.map((item, index) => (
                      <tr key={index}>
                        <td>{item.reference_no}</td>
                        <td className="text-center">{item.quantity}</td>
                        <td className="text-end">{item.price}</td>
                        <td>{item.delivery_date}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Header />
      <div className="breadcrumbs">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-12 col-sm-12">
              <a href="#"><i className="fa fa-home"></i></a> &gt;
              <a href="/Dashboard">Dashboard</a> &gt;
              <span className="last-crumb">New Sales Order</span>
            </div>
          </div>
        </div>
      </div>

      <div className="main-container">
        <form id='new_sales_order' autoComplete="off">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 col-lg-12 col-sm-12">
                <div className="show-order-area dashboard">
                  <div style={{ marginBottom: '20px', float: 'left', width: '100%' }}>
                    <div className="topsearch-area">
                      <div className="row">
                        <div className="col-12 col-lg-6 col-sm-6">
                          <div className="row">
                            <div className="row">
                              <label htmlFor="inputText" className="col-sm-3 col-form-label">Customer:</label>
                              <div className="col-sm-7">
                                <Select
                                  isClearable
                                  name="customer_id"
                                  onChange={(e) => handleCustomerChange(e, { customer_id: e?.value }, null, setInvoiceAddress, setDeliveryAddrDropdown, setDeliveryAddresses, setInputDeliveryAddresses)}
                                  options={customerData}
                                  placeholder="Select Customer"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-12 col-lg-6 col-sm-6">
                          <div style={{ float: "right" }}>
                            <p>
                              <label className="checkbox">
                                <input
                                  type="checkbox"
                                  name='save_as_proforma'
                                  checked={saveAsProforma}
                                  onChange={(e) => setSaveAsProforma(e.target.checked)}
                                />
                                <span className="default"></span>
                              </label>
                              <span>Save as Proforma</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="accordion" id="accordionPanelsStayOpenExample">
                      <div className="accordion-item accordion-item-two">
                        <h2 className="accordion-header" id="panelsStayOpen-headingTwo">
                          <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseTwo" aria-expanded="false" aria-controls="panelsStayOpen-collapseTwo">
                            Invoice Address <div className="red">*</div>
                          </button>
                        </h2>
                        <div id="panelsStayOpen-collapseTwo" className="accordion-collapse collapse show" aria-labelledby="panelsStayOpen-headingTwo">
                          <div className="accordion-body">
                            <div className="newsalesorderform" style={{ margin: '0' }}>
                              <div className="row mb-3 padd-l-13px">
                                <div className="col-6 col-lg-6 col-sm-6">
                                  <div className="row mb-3">
                                    <div className="col-4 col-lg-3 col-sm-3">
                                      <label htmlFor="desc" className="col-form-label">Address Line 1 </label>
                                    </div>
                                    <div className="col-8 col-lg-9 col-sm-9">
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="addr1"
                                        value={invoiceAddress.billing_address_line1}
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          if (validateAddressField(value, 'address_line1', 'invoice')) {
                                            setInvoiceAddress(prev => ({
                                              ...prev,
                                              billing_address_line1: value
                                            }));
                                          }
                                        }}
                                        maxLength={255}
                                        autoComplete="off"
                                      />
                                      <FormText error={!!addressErrors.invoice_address_line1}>
                                        {addressErrors.invoice_address_line1}
                                      </FormText>
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <div className="col-4 col-lg-3 col-sm-3">
                                      <label htmlFor="desc" className="col-form-label">Address Line 2 </label>
                                    </div>
                                    <div className="col-8 col-lg-9 col-sm-9">
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="addr2"
                                        value={invoiceAddress.billing_address_line2}
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          if (validateAddressField(value, 'address_line2', 'invoice')) {
                                            setInvoiceAddress(prev => ({
                                              ...prev,
                                              billing_address_line2: value
                                            }));
                                          }
                                        }}
                                        maxLength={255}
                                        autoComplete="off"
                                      />
                                      <FormText error={!!addressErrors.invoice_address_line2}>
                                        {addressErrors.invoice_address_line2}
                                      </FormText>
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <div className="col-4 col-lg-3 col-sm-3">
                                      <label htmlFor="desc" className="col-form-label">City </label>
                                    </div>
                                    <div className="col-8 col-lg-3 col-sm-3">
                                      <input
                                        type="text"
                                        className="form-control"
                                        value={invoiceAddress.billing_city}
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          if (validateAddressField(value, 'city', 'invoice')) {
                                            setInvoiceAddress(prev => ({
                                              ...prev,
                                              billing_city: value
                                            }));
                                          }
                                        }}
                                        maxLength={50}
                                        autoComplete="off"
                                      />
                                      <FormText error={!!addressErrors.invoice_city}>
                                        {addressErrors.invoice_city}
                                      </FormText>
                                    </div>

                                    <div className="col-4 col-lg-3 col-sm-3">
                                      <label htmlFor="desc" className="col-form-label">Country </label>
                                    </div>
                                    <div className="col-8 col-lg-3 col-sm-3">
                                      <input
                                        type="text"
                                        className="form-control"
                                        value={invoiceAddress.billing_country}
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          if (validateAddressField(value, 'country', 'invoice')) {
                                            setInvoiceAddress(prev => ({
                                              ...prev,
                                              billing_country: value
                                            }));
                                          }
                                        }}
                                        maxLength={50}
                                        autoComplete="off"
                                      />
                                      <FormText error={!!addressErrors.invoice_country}>
                                        {addressErrors.invoice_country}
                                      </FormText>
                                    </div>
                                  </div>

                                  <div className="row mb-3">
                                    <div className="col-4 col-lg-3 col-sm-3">
                                      <label htmlFor="desc" className="col-form-label">Post Code </label>
                                    </div>
                                    <div className="col-8 col-lg-9 col-sm-9">
                                      <input
                                        type="text"
                                        className="form-control"
                                        value={invoiceAddress.billing_postcode}
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          if (validateAddressField(value, 'postcode', 'invoice')) {
                                            setInvoiceAddress(prev => ({
                                              ...prev,
                                              billing_postcode: value
                                            }));
                                          }
                                        }}
                                        maxLength={50}
                                        autoComplete="off"
                                      />
                                      <FormText error={!!addressErrors.invoice_postcode}>
                                        {addressErrors.invoice_postcode}
                                      </FormText>
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <div className="col-4 col-lg-3 col-sm-3">
                                      <label htmlFor="desc" className="col-form-label">VAT </label>
                                    </div>
                                    <div className="col-8 col-lg-9 col-sm-9">
                                      <input
                                        type="text"
                                        className="form-control"
                                        value={invoiceAddress.vat_number}
                                        onChange={(e) => setInvoiceAddress(prev => ({
                                          ...prev,
                                          vat_number: e.target.value
                                        }))}
                                        onInput={handleVatValidation}
                                        name="salecustomerVat"
                                        id="salecustomerVat"
                                      />
                                    </div>
                                  </div>
                                </div>

                                <div className="col-6 col-lg-6 col-sm-6">
                                  <div className="row mb-3">
                                    <div className="col-3 col-lg-3 col-sm-3">
                                      <label className="col-form-label padd-left-50">
                                        Customer Address
                                      </label>
                                    </div>
                                    <div className="col-1 col-lg-1 col-sm-1" style={{ paddingTop: '8px' }}>
                                      <input
                                        type="radio"
                                        name="delivery_type"
                                        id="delivery_type"
                                        value="delivery"
                                        defaultChecked
                                        onChange={(e) => handleDeliveryandCollectionAddress(e)}
                                        style={{ float: "left" }}
                                      />
                                    </div>

                                    <div className="col-3 col-lg-3 col-sm-3">
                                      <label className="col-form-label padd-left-50">
                                        Collection Address
                                      </label>
                                    </div>
                                    <div className="col-3 col-lg-3 col-sm-3" style={{ paddingTop: '8px' }}>
                                      <input
                                        type="radio"
                                        name="delivery_type"
                                        id="delivery_type"
                                        value="collection"
                                        onChange={(e) => handleDeliveryandCollectionAddress(e)}
                                        style={{ float: "left" }}
                                      />
                                    </div>
                                  </div>

                                  {deliveryType === 'delivery' && (
                                    <div>
                                      <div className="row mb-3">
                                        <div className="col-4 col-lg-3 col-sm-3">
                                          <label htmlFor="desc" className="col-form-label"><strong>Delivery Address </strong></label>
                                        </div>
                                        <div className="col-8 col-lg-9 col-sm-9">
                                          <select name="delivery_id" onChange={(e) => getDeliveryAddrById(e, deliveryAddrDropdown, setInputDeliveryAddresses)} className='form-select orgselect'>
                                            <option>Select</option>
                                            {deliveryAddrDropdown && Array.isArray(deliveryAddrDropdown) && deliveryAddrDropdown.map((option) => (
                                              <option key={option.id} value={option.id}>
                                                {option.address_line1}
                                              </option>
                                            ))}
                                          </select>
                                        </div>
                                      </div>
                                      <div className="row mb-3">
                                        <div className="col-4 col-lg-3 col-sm-3">
                                          <label htmlFor="desc" className="col-form-label">Address Line 1 </label>
                                        </div>
                                        <div className="col-8 col-lg-9 col-sm-9">
                                          <input
                                            type="text"
                                            name="addr1"
                                            className="form-control"
                                            value={inputDeliveryAddresses.address_line1}
                                            onChange={(e) => {
                                              const value = e.target.value;
                                              if (validateAddressField(value, 'address_line1', 'delivery')) {
                                                setInputDeliveryAddresses(prev => ({
                                                  ...prev,
                                                  address_line1: value
                                                }));
                                              }
                                            }}
                                            maxLength={255}
                                            autoComplete="off"
                                          />
                                          <FormText error={!!addressErrors.delivery_address_line1}>
                                            {addressErrors.delivery_address_line1}
                                          </FormText>
                                        </div>
                                      </div>
                                      <div className="row mb-3">
                                        <div className="col-4 col-lg-3 col-sm-3">
                                          <label htmlFor="desc" className="col-form-label">Address Line 2 </label>
                                        </div>
                                        <div className="col-8 col-lg-9 col-sm-9">
                                          <input
                                            type="text"
                                            name="addr2"
                                            className="form-control"
                                            value={inputDeliveryAddresses.address_line2}
                                            onChange={(e) => {
                                              const value = e.target.value;
                                              if (validateAddressField(value, 'address_line2', 'delivery')) {
                                                setInputDeliveryAddresses(prev => ({
                                                  ...prev,
                                                  address_line2: value
                                                }));
                                              }
                                            }}
                                            maxLength={255}
                                            autoComplete="off"
                                          />
                                          <FormText error={!!addressErrors.delivery_address_line2}>
                                            {addressErrors.delivery_address_line2}
                                          </FormText>
                                        </div>
                                      </div>
                                      <div className="row mb-3">
                                        <div className="col-4 col-lg-3 col-sm-3">
                                          <label htmlFor="desc" className="col-form-label">City </label>
                                        </div>
                                        <div className="col-8 col-lg-3 col-sm-3">
                                          <input
                                            type="text"
                                            name="city"
                                            className="form-control"
                                            value={inputDeliveryAddresses.city}
                                            onChange={(e) => {
                                              const value = e.target.value;
                                              if (validateAddressField(value, 'city', 'delivery')) {
                                                setInputDeliveryAddresses(prev => ({
                                                  ...prev,
                                                  city: value
                                                }));
                                              }
                                            }}
                                            maxLength={50}
                                            autoComplete="off"
                                          />
                                          <FormText error={!!addressErrors.delivery_city}>
                                            {addressErrors.delivery_city}
                                          </FormText>
                                        </div>

                                        <div className="col-4 col-lg-3 col-sm-3">
                                          <label htmlFor="desc" className="col-form-label">Country </label>
                                        </div>
                                        <div className="col-8 col-lg-3 col-sm-3">
                                          <input
                                            type="text"
                                            name="country"
                                            className="form-control"
                                            value={inputDeliveryAddresses.country}
                                            onChange={(e) => {
                                              const value = e.target.value;
                                              if (validateAddressField(value, 'country', 'delivery')) {
                                                setInputDeliveryAddresses(prev => ({
                                                  ...prev,
                                                  country: value
                                                }));
                                              }
                                            }}
                                            maxLength={50}
                                            autoComplete="off"
                                          />
                                          <FormText error={!!addressErrors.delivery_country}>
                                            {addressErrors.delivery_country}
                                          </FormText>
                                        </div>
                                      </div>

                                      <div className="row mb-3">
                                        <div className="col-4 col-lg-3 col-sm-3">
                                          <label htmlFor="desc" className="col-form-label">Post Code </label>
                                        </div>
                                        <div className="col-8 col-lg-9 col-sm-9">
                                          <input
                                            type="text"
                                            name="post_code"
                                            className="form-control"
                                            value={inputDeliveryAddresses.post_code}
                                            onChange={(e) => {
                                              const value = e.target.value;
                                              if (validateAddressField(value, 'postcode', 'delivery')) {
                                                setInputDeliveryAddresses(prev => ({
                                                  ...prev,
                                                  post_code: value
                                                }));
                                              }
                                            }}
                                            maxLength={50}
                                            autoComplete="off"
                                          />
                                          <FormText error={!!addressErrors.delivery_postcode}>
                                            {addressErrors.delivery_postcode}
                                          </FormText>
                                        </div>
                                      </div>
                                    </div>
                                  )}

                                  {deliveryType === 'collection' && (
                                    <div>
                                      <div className="row mb-3">
                                        <div className="col-3">
                                          <label className="col-form-label">Address Line 1 </label>
                                        </div>
                                        <div className="col-9">
                                          <input
                                            type="text"
                                            name="addr1"
                                            className="form-control"
                                            value={inputCollectionAddresses.address_line1}
                                            onChange={(e) => {
                                              const value = e.target.value;
                                              if (validateAddressField(value, 'address_line1', 'collection')) {
                                                setInputCollectionAddresses({ ...inputCollectionAddresses, address_line1: value });
                                              }
                                            }}
                                            maxLength={255}
                                            autoComplete="off"
                                          />
                                          <FormText error={!!addressErrors.collection_address_line1}>
                                            {addressErrors.collection_address_line1}
                                          </FormText>
                                        </div>
                                      </div>
                                      <div className="row mb-3">
                                        <div className="col-3">
                                          <label className="col-form-label">Address Line 2 </label>
                                        </div>
                                        <div className="col-9">
                                          <input
                                            type="text"
                                            name="addr2"
                                            className="form-control"
                                            value={inputCollectionAddresses.address_line2}
                                            onChange={(e) => {
                                              const value = e.target.value;
                                              if (validateAddressField(value, 'address_line2', 'collection')) {
                                                setInputCollectionAddresses({ ...inputCollectionAddresses, address_line2: value });
                                              }
                                            }}
                                            maxLength={255}
                                            autoComplete="off"
                                          />
                                          <FormText error={!!addressErrors.collection_address_line2}>
                                            {addressErrors.collection_address_line2}
                                          </FormText>
                                        </div>
                                      </div>
                                      <div className="row mb-3">
                                        <div className="col-3">
                                          <label className="col-form-label">City </label>
                                        </div>
                                        <div className="col-3">
                                          <input
                                            type="text"
                                            name="city"
                                            className="form-control"
                                            value={inputCollectionAddresses.city}
                                            onChange={(e) => {
                                              const value = e.target.value;
                                              if (validateAddressField(value, 'city', 'collection')) {
                                                setInputCollectionAddresses({ ...inputCollectionAddresses, city: value });
                                              }
                                            }}
                                            maxLength={50}
                                            autoComplete="off"
                                          />
                                          <FormText error={!!addressErrors.collection_city}>
                                            {addressErrors.collection_city}
                                          </FormText>
                                        </div>

                                        <div className="col-3">
                                          <label className="col-form-label">Country </label>
                                        </div>
                                        <div className="col-3">
                                          <input
                                            type="text"
                                            name="country"
                                            className="form-control"
                                            value={inputCollectionAddresses.country}
                                            onChange={(e) => {
                                              const value = e.target.value;
                                              if (validateAddressField(value, 'country', 'collection')) {
                                                setInputCollectionAddresses({ ...inputCollectionAddresses, country: value });
                                              }
                                            }}
                                            maxLength={50}
                                            autoComplete="off"
                                          />
                                          <FormText error={!!addressErrors.collection_country}>
                                            {addressErrors.collection_country}
                                          </FormText>
                                        </div>
                                      </div>

                                      <div className="row mb-3">
                                        <div className="col-4 col-lg-3 col-sm-3">
                                          <label className="col-form-label">Post Code </label>
                                        </div>
                                        <div className="col-8 col-lg-9 col-sm-9">
                                          <input
                                            type="text"
                                            name="post_code"
                                            className="form-control"
                                            value={inputCollectionAddresses.post_code}
                                            onChange={(e) => {
                                              const value = e.target.value;
                                              if (validateAddressField(value, 'postcode', 'collection')) {
                                                setInputCollectionAddresses({ ...inputCollectionAddresses, post_code: value });
                                              }
                                            }}
                                            maxLength={50}
                                            autoComplete="off"
                                          />
                                          <FormText error={!!addressErrors.collection_postcode}>
                                            {addressErrors.collection_postcode}
                                          </FormText>
                                        </div>
                                      </div>
                                    </div>
                                  )}

                                  <div className="row mb-3">
                                    <div className="col-4 col-lg-3 col-sm-3">
                                      <label htmlFor="desc" className="col-form-label">Delivery Date </label>
                                    </div>
                                    <div className="col-6 col-lg-3 col-sm-3">
                                      <CustomDateInput
                                        name="delivery_date"
                                        id="delivery_date"
                                        className="form-control"
                                      />
                                    </div>
                                    <div className="col-6 col-lg-3 col-sm-3">
                                      <label htmlFor="desc" className="col-form-label">Delivery Time </label>
                                    </div>
                                    <div className="col-6 col-lg-3 col-sm-3">
                                      <input type="time" className="form-control" name="delivery_time" id="delivery_time" step="600" />
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <div className="col-4 col-lg-3 col-sm-3">
                                      <label htmlFor="desc" className="col-form-label">Customer Ref <span className="text-danger">*</span></label>
                                    </div>
                                    <div className="col-8 col-lg-9 col-sm-9">
                                      <input type="text" className="form-control" name="customer_ref" id="customer_ref" autoComplete='off' />
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-4 col-lg-3 col-sm-3">
                                      <label htmlFor="desc" className="col-form-label">Job Ref </label>
                                    </div>
                                    <div className="col-6 col-lg-3 col-sm-3">
                                      <input 
                                        type="text" 
                                        className="form-control" 
                                        name="job_ref" 
                                        id="job_ref" 
                                        autoComplete='off'
                                        maxLength={100}
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          validateJobRef(value);
                                        }}
                                      />
                                      <FormText error={!!jobRefError}>{jobRefError}</FormText>
                                    </div>
                                    <div className="col-6 col-lg-3 col-sm-3">
                                      <label htmlFor="desc" className="col-form-label">Booking Ref </label>
                                    </div>
                                    <div className="col-6 col-lg-3 col-sm-3">
                                      <input 
                                        type="text" 
                                        className="form-control" 
                                        name="booking_ref" 
                                        id="booking_ref" 
                                        autoComplete='off'
                                        maxLength={100}
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          validateBookingRef(value);
                                        }}
                                      />
                                      <FormText error={!!bookingRefError}>{bookingRefError}</FormText>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="topsearch-area">
                      <div className="row">
                        <div className="col-12 col-lg-3 col-sm-3">
                          <button
                            type="button"
                            onClick={(e) => {
                              e.preventDefault();
                              getProductList();
                            }}
                            className="create-catalogue-btn-left"
                          >
                            Add New Product
                          </button>
                        </div>
                        <div className="col-12 col-lg-3 col-sm-3">
                          <div className="col-12 col-lg-12 col-sm-12">
                            <div className='row'>
                              {/* Product selection can be added here if needed */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="verical-scrl-wrapper common-table newsalesorder-table" id="style-3">
                      <table className="table table-bordered dataTable" id="dsTable">
                        <thead>
                          <tr>
                            <th>Code</th>
                            <th>Description</th>
                            <th>Pack</th>
                            <th>Size</th>
                            <th>Case Qty</th>
                            <th>Selling Price</th>
                            <th>Cost Price</th>
                            <th>Value</th>
                            <th>Profit</th>
                            <th>VAT</th>
                            <th>Stock</th>
                            <th>On PO</th>
                            <th>F.Stk</th>
                            <th>Mapped P.O No.</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {tableRows.length === 0 ? (
                            <tr style={{ textAlign: "center" }}>
                              <td colSpan={15}>No product added</td>
                            </tr>
                          ) : (
                            tableRows.map((row) => (
                              <tr key={row.id}>
                                <td>
                                  <input type="hidden" name="product_id[]" value={row.id} />
                                  <input type="hidden" name="code[]" value={row.code} />
                                  <input type="hidden" name="batch_id[]" value={row.batch_id} />
                                  <input type="hidden" name="purchase_id[]" value={row.purchase_id} />

                                  {isSpecialLineItem(row.code) ? (
                                    <span>{row.code}</span>
                                  ) : (
                                    <Link
                                      to="#"
                                      onClick={() => getProductBatchData(row.id, row.batch_id || null, row.purchase_id || null)}
                                      data-bs-toggle="modal"
                                      data-bs-target="#viw-pst-invs"
                                    >
                                      {row.code}
                                    </Link>
                                  )}
                                </td>
                                <td>
                                  <p className="cut-text">
                                    {isSpecialLineItem(row.code) ? (
                                      <span>{row.product_desc}</span>
                                    ) : (
                                      <a
                                        data-bs-toggle="modal"
                                        className="applybtn"
                                        data-id={row.id}
                                        data-bs-target="#viewproduct"
                                        href="#"
                                        onClick={() => setSelectedProductId(row.id)}
                                      >
                                        {row.product_desc}
                                      </a>
                                    )}
                                  </p>
                                </td>
                                <td>
                                  <input type="hidden" name="packsize[]" value={row.pack} /> {row.pack}
                                </td>
                                <td>
                                  <input type="hidden" name="productSize[]" value={row.size} /> {row.size}
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    name="qty[]"
                                    value={row.pdtqty || ''}
                                    className="form-control qtyinputbox"
                                    disabled={isSpecialLineItem(row.code)}
                                    onFocus={(e) => e.target.select()}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      if (isSpecialLineItem(row.code)) {
                                        setTableRows((prev) => prev.map(r => r.id === row.id ? { ...r, pdtqty: value } : r));
                                      } else if (validateQuantity(value, row.id)) {
                                        handleInputChangeInSalesNew(e, row.id, "pdtqty", setTableRows);
                                      } else {
                                        setTableRows((prev) => prev.map(r => r.id === row.id ? { ...r, pdtqty: value } : r));
                                      }
                                    }}
                                    autoComplete='off'
                                  />
                                  <FormText error={!!(fieldErrors[row.id]?.qty)}>
                                    {fieldErrors[row.id]?.qty}
                                  </FormText>
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    name="price[]"
                                    className="form-control qtyinputbox"
                                    value={row.price && parseFloat(row.price) !== 0 ? row.price : ''}
                                    onFocus={(e) => e.target.select()}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      if (isSpecialLineItem(row.code)) {
                                        const numValue = parseFloat(value) || 0;
                                        setTableRows((prev) => prev.map(r => {
                                          if (r.id === row.id) {
                                            return { ...r, price: value, cost: numValue, value: numValue };
                                          }
                                          return r;
                                        }));
                                      } else if (validatePrice(value, row.id)) {
                                        handleInputChangeInSalesNew(e, row.id, "price", setTableRows);
                                      } else {
                                        setTableRows((prev) => prev.map(r => r.id === row.id ? { ...r, price: value } : r));
                                      }
                                    }}
                                    step="0.01"
                                    autoComplete='off'
                                  />
                                  <FormText error={!!(fieldErrors[row.id]?.price)}>
                                    {fieldErrors[row.id]?.price}
                                  </FormText>
                                </td>
                                <td style={{ textAlign: 'right' }}>
                                  <input
                                    type="text"
                                    name="cost[]"
                                    className="form-control qtyinputbox"
                                    value={row.cost && parseFloat(row.cost) !== 0 ? row.cost : ''}
                                    disabled={isSpecialLineItem(row.code)}
                                    onFocus={(e) => e.target.select()}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      if (isSpecialLineItem(row.code)) {
                                        setTableRows((prev) => prev.map(r => r.id === row.id ? { ...r, cost: value } : r));
                                      } else if (validateCost(value, row.id)) {
                                        handleInputChangeInSalesNew(e, row.id, "cost", setTableRows);
                                      } else {
                                        setTableRows((prev) => prev.map(r => r.id === row.id ? { ...r, cost: value } : r));
                                      }
                                    }}
                                    step="0.01"
                                    autoComplete='off'
                                  />
                                  <FormText error={!!(fieldErrors[row.id]?.cost)}>
                                    {fieldErrors[row.id]?.cost}
                                  </FormText>
                                </td>
                                <td style={{ textAlign: 'right' }}>{(parseFloat(row.value) || 0).toFixed(2)}</td>
                                <td style={{ textAlign: 'right' }}>
                                  <input type="hidden" name="profit[]" value={row.cost > 0
                                    ? (((row.price - row.cost) / row.cost) * 100).toFixed(2)
                                    : "0.00"} />
                                  {row.cost > 0
                                    ? (((row.price - row.cost) / row.cost) * 100).toFixed(2)
                                    : "0.00"}
                                </td>
                                <td className="text-end">
                                  <input type="hidden" name="vat[]" value={isSpecialLineItem(row.code) ? "0.00" : (((parseFloat(row.value) || 0) / 100) * (parseFloat(row.vat) || 0)).toFixed(2)} />
                                  {isSpecialLineItem(row.code) ? "0.00" : (((parseFloat(row.value) || 0) / 100) * (parseFloat(row.vat) || 0)).toFixed(2)}
                                </td>
                                <td className="text-end">
                                  <input type="hidden" name="stock[]" value={row.quantity} />
                                  {row.quantity}
                                </td>
                                <td style={{ textAlign: 'right' }}>
                                  <input type="hidden" name="onPO[]" value="0" />
                                  {row.onpurchase}
                                </td>
                                <td style={{ textAlign: 'right' }}>
                                  <input type="hidden" name="onSO[]" value="0" />
                                  {Number(row.freestock)}
                                </td>
                                <td style={{ textAlign: 'right' }}>
                                  <input type="hidden" name="fstk[]" value="0" />
                                  {row.batch_id !== 0 ? (
                                    (() => {
                                      const ids = Array.isArray(row.purchase_id)
                                        ? row.purchase_id
                                        : typeof row.purchase_id === 'string'
                                          ? row.purchase_id.split(',').map((id) => id.trim()).filter(Boolean)
                                          : (row.purchase_id && row.purchase_id !== 0 ? [row.purchase_id] : []);
                                      return ids.length > 0
                                        ? ids.map((id, index) => (
                                          <span key={index}>
                                            PO{id}{index < ids.length - 1 ? ', ' : ''}
                                          </span>
                                        ))
                                        : '';
                                    })()
                                  ) : (
                                    <span>{row.mappedPO ? row.mappedPO : ''}</span>
                                  )}
                                </td>
                                <td>
                                  <Link
                                    to="#"
                                    onClick={() => removeRow(row.id, setTableRows)}
                                  >
                                    <i className="fa fa-trash"></i>
                                  </Link>
                                </td>
                                <input type="hidden" name="stdGoods" value={totalVal.stdGoods.toFixed(2)} />
                                <input type="hidden" name="vatAmt" value={totalVal.vatAmt.toFixed(2)} />
                                <input type="hidden" name="zeroGoods" value={totalVal.zeroGoods.toFixed(2)} />
                                <input type="hidden" name="grandTotal" value={totalVal.grandTotal.toFixed(2)} />
                                <input type="hidden" name="totalItems" value={totalVal.totalItems} />
                                <input type="hidden" name="grossWeight" value={totalVal.grossWeight} />
                                <input type="hidden" name="netWeight" value={totalVal.netWeight} />
                                <input type="hidden" name="cube" value={totalVal.cbm} />
                                <input type="hidden" name="grossProfit" value={totalVal.totalProfit.toFixed(2)} />
                                <input type="hidden" name="grossProfitPercent" value={totalVal.totalProfitPercent.toFixed(2)} />
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>

                    <div className="newsalesorderftr">
                      <div className="row">
                        <div className="col-6 col-lg-3 col-sm-3">Std Rated : {totalVal.stdGoods.toFixed(2)} </div>
                        <div className="col-6 col-lg-3 col-sm-3">VAT Amount : {totalVal.vatAmt.toFixed(2)} </div>
                        <div className="col-6 col-lg-3 col-sm-3">Zero Rated : {totalVal.zeroGoods.toFixed(2)}</div>
                        <div className="col-6 col-lg-3 col-sm-3">Grand Total : {totalVal.grandTotal.toFixed(2)}</div>
                      </div>
                    </div>
                    <div className="newsalesorderftr">
                      <div className="row">
                        <div className="col-6 col-lg-3 col-sm-3">Total Items :  {totalVal.totalItems} </div>
                        <div className="col-6 col-lg-3 col-sm-3">Gross Weight : {totalVal.grossWeight} KGS</div>
                        <div className="col-6 col-lg-3 col-sm-3">Net Weight : {totalVal.netWeight} KGS</div>
                        <div className="col-6 col-lg-3 col-sm-3">Cube : {totalVal.cbm} M3</div>
                      </div>
                    </div>

                    <button className='clickherebtn'>Show Gross Profit</button>
                    <div class="data">
                      <div className="newsalesorderftr">
                        <div className="row">
                          <div className="col-6 col-lg-6 col-sm-6">Gross Profit : {totalVal.totalProfit.toFixed(2)}</div>
                          <div className="col-6 col-lg-6 col-sm-6">Gross Profit % : {totalVal.totalProfitPercent.toFixed(2)}%</div>
                        </div>
                      </div>
                    </div>

                    <div>
                      <div className="row mb-3">
                        <div className="col-6 col-lg-2 col-sm-2">
                          <label htmlFor="desc" className="col-form-label">Notes :</label></div>
                        <div className="col-6 col-lg-4 col-sm-4">
                          <textarea 
                            className="form-control" 
                            name="notes" 
                            id="notes" 
                            placeholder="" 
                            style={{ height: '100px' }}
                            maxLength={500}
                            onChange={(e) => {
                              const value = e.target.value;
                              validateNotes(value);
                            }}
                          ></textarea>
                          <FormText error={!!notesError}>{notesError}</FormText>
                        </div>
                      </div>
                    </div>

                    <hr />
                    <a href="#" className="popup-innerbtn-common" onClick={handleSaveClick}>Save Sales Order</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <Footer />
    </div>
  );
};

export default NewSalesOrder;
